import { getConsentedBuyerId, getGuestId } from 'dibs-cookie-jar';
import { removeLocaleSegment } from 'dibs-intl/exports/urls';

import { type UserTrackingItemInputType } from './__generated__/trackUserEventMutation.graphql.ts';

const pdpPageIdRegex = /\/id-[fajv]_\d+\/$/;

export const getPageId = (): string =>
    `${removeLocaleSegment(window.location.pathname)}${window.location.search}`;

export const getTruncatedPdpPageId = (): string | null =>
    window.location.pathname.match(pdpPageIdRegex)?.[0] || null;

export const getUserData = (): { userId: string; sessionId: string } => {
    const sessionId = getGuestId(document.cookie) || '';
    const userId = getConsentedBuyerId(document.cookie) || '';

    return { userId, sessionId };
};

export type userEventItem = UserTrackingItemInputType;

export const getUserEventItem = (args: {
    id: unknown;
    amount: unknown;
    convertedAmounts?: unknown;
    currency?: string | null;
    quantity?: number | null;
}): userEventItem | null => {
    const { id, amount } = args;
    if (typeof id === 'string' && id && typeof amount === 'number' && amount) {
        const currency = args.currency || 'USD';
        const quantity = args.quantity || 1;
        const convertedAmounts = args.convertedAmounts || {};

        return {
            id,
            quantity,
            price: {
                amount,
                currency,
                convertedAmounts,
            },
        };
    }
    return null;
};
